module.exports = __webpack_public_path__ + "img/tutorial-icon.5b9153e0.svg";